<template>
  <section class="swiper-content" :id="id">
    <swiper
      class="swiper"
      ref="swiper"
      :breakpoints="breakpoints"
      :navigation="pagination"
      :modules="modules"
      :autoplay="autoplay"
      :initial-slide="index"
      @slideChange="changedSlide"
      @swiper="loadSwiper"
    >
      <slot />
    </swiper>
  </section>
</template>
<script>
// https://swiperjs.com/vue#swiper-events
import { Navigation, Autoplay } from "swiper";
import { Swiper } from "swiper/vue";
import { ref } from "vue";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";

export default {
  components: {
    Swiper,
  },
  props: {
    id: {
      type: String,
    },
    index: {
      type: [Number, String],
      default: () => 0,
    },
    autoplay: {
      type: Object,
      default: () => {},
    },
    pagination: {
      type: Boolean,
      default: () => true,
    },
    breakpoints: {
      type: String,
      default: () => {},
    },
  },
  methods: {
    changedSlide(swiper) {
      // skip init change slide
      if (this.skipInitCounter) {
        this.skipInitCounter--;
        return;
      }
      this.$emit("changed-slide",  swiper.activeIndex);
    },
  },
  setup(props) {
    const modules = [Navigation, Autoplay];
    const skipInitCounter = ref(0);
    // if setting specific index on init - skip change slide emit
    if (props.index) {
      skipInitCounter.value = 1;
    }

    return {
      modules,
      skipInitCounter,
    };
  },
};
</script>
